module.exports = __webpack_public_path__ + "img/spark.12c4b2c2.png";